import { useEffect, useState } from "react";
import { getUserApi } from "../api";

type BootstrapState = "idle" | "polling" | "ready";

export function useUserObjectExists(userId: string | null, enabled: boolean) {
    const [state, setState] = useState<BootstrapState>("idle");

    useEffect(() => {
        if (!enabled || !userId) {
            setState("idle");
            return;
        }

        let cancelled = false;
        let timeoutId: number | undefined;

        const poll = async () => {
            if (cancelled) return;
            setState("polling");

            try {
                const user = await getUserApi(userId);

                if (cancelled) return;

                if (user) {
                    setState("ready");
                    return;
                }

                timeoutId = window.setTimeout(poll, 1000);
            } catch (err) {
                if (!cancelled) console.error(err instanceof Error ? err.message : "Failed to check account status");
                timeoutId = window.setTimeout(poll, 1000);
            }
        };

        void poll();

        return () => {
            cancelled = true;
            if (timeoutId) window.clearTimeout(timeoutId);
        };
    }, [enabled, userId]);

    return { userBootstrapState: state };
}
